import '../styles/DashboardRunStats.css';
import React from 'react';
import { useProjectCollection } from '../lib/projectData';

const CHIPS = [
  { key: 'total', ground: 'total', label: 'Total runs', mark: true },
  { key: 'complete', ground: 'complete', label: 'Completed', mark: true },
  { key: 'failed', ground: 'failed', label: 'Failed', mark: false },
  { key: 'running', ground: 'running', label: 'Running', mark: false },
];

function pluralise(n, singular, plural) {
  return `${n} ${n === 1 ? singular : plural}`;
}

export default function DashboardRunStats() {
  const { data, loading, error, refresh } = useProjectCollection('test_run');

  const runs = Array.isArray(data) ? data : [];
  const counts = {
    total: runs.length,
    complete: runs.filter((r) => r && r.state === 'complete').length,
    failed: runs.filter((r) => r && r.state === 'failed').length,
    running: runs.filter((r) => r && r.state === 'running').length,
  };

  const showSkeleton = loading && runs.length === 0;

  const handleRetry = () => {
    if (typeof refresh === 'function') refresh();
  };

  return (
    <section className="drst-root" aria-labelledby="drst-title">
      <div className="drst-inner" data-content-rail="workspace">
        <p className="drst-eyebrow" id="drst-title">
          <span className="drst-eyebrow__mark">Run board</span>
          {!showSkeleton && !error && counts.total > 0
            ? <span aria-live="polite">· {pluralise(counts.total, 'run', 'runs')} recorded locally</span>
            : null}
        </p>

        {error ? (
          <div className="drst-error" role="alert">
            <span className="drst-error__tag">Read failed</span>
            <p className="drst-error__msg">
              {typeof error === 'string' && error ? error : 'The local run store could not be read.'}
            </p>
            <button type="button" className="drst-error__retry" onClick={handleRetry}>
              Retry
            </button>
          </div>
        ) : (
          <ul className="drst-strip">
            {CHIPS.map((chip) => (
              <li className={`drst-chip drst-chip--${chip.ground}${showSkeleton ? ' drst-chip--loading' : ''}`} key={chip.key}>
                {showSkeleton ? (
                  <>
                    <span className="drst-skeleton drst-skeleton--value" aria-hidden="true" />
                    <span className="drst-skeleton drst-skeleton--label" aria-hidden="true" />
                    <span className="drst-visually-hidden">Counting {chip.label.toLowerCase()}</span>
                  </>
                ) : (
                  <>
                    <span className="drst-chip__stamp" aria-hidden="true" />
                    <span className="drst-chip__value">{counts[chip.key]}</span>
                    <span className="drst-chip__foot">
                      <span className="drst-chip__label">{chip.label}</span>
                      {chip.mark ? <span className="drst-chip__mark" aria-hidden="true" /> : null}
                    </span>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}